import { NavLink } from 'react-router-dom'
import { faAnglesRight } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Image } from '@/ui'
import { MobileMenu } from '../MobileMenu'
import { mtc } from '@/styles'
import { iconStyles } from './stylesRestructured'

interface HeaderProps {
  className?: string
  device: string
  handleIconClick: () => void
  isOpen: boolean
}

export const Header = ({
  className,
  device,
  isOpen,
  handleIconClick,
}: HeaderProps) => {
  return (
    <header
      className={mtc('relative flex items-center px-2 w-full h-12', className)}
    >
      <NavLink to="/dashboard" className="flex items-center">
        {device !== 'desktop' ? (
          <MobileMenu
            onClick={handleIconClick}
            onKeyDown={handleIconClick}
            isOpen={isOpen}
          />
        ) : (
          // Render the full "Heard" wordmark but clip to the width of its "H"
          // glyph, so the collapsed mark is the exact same image at the exact
          // same scale as the expanded logo, guaranteeing a pixel-identical H.
          // 18.52px is the H glyph's rendered width at this logo height.
          <span className="block h-6 w-[18.52px] overflow-hidden">
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/full-heard-logo.svg"
              alt="heard logo"
              height={24}
              width={85}
              className="h-6 w-auto max-w-none shrink-0"
            />
          </span>
        )}
      </NavLink>

      <Icon
        className={mtc(
          iconStyles(),
          'absolute left-1/2 -translate-x-1/2 top-full mt-3',
          device !== 'desktop' && 'h-4 w-4'
        )}
        color="text-neutral-600"
        icon={faAnglesRight}
        onClick={handleIconClick}
      />
    </header>
  )
}
